/* eslint-disable no-unused-expressions */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React, { useRef } from "react";
import "../../App.css";
import DataTable from "react-data-table-component";
import axios from "axios";
import { endpoints } from "../../services/apiurl";
import { withRouter } from "react-router";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { Button, Card, TextField } from "@mui/material";
import { InfinitySpin } from "react-loader-spinner";
const customStyles = {
  headCells: {
    style: {
      fontSize: "15px",
      fontWeight: "600",
      color: "#212529",
      backgroundColor: "#f8f9fa",
      width: "100%",
    },
  },
};
class ReservationLeads extends React.Component {
  // Constructor
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      DataisLoaded: false,
      restaurent: [],
      restaurent_outlet: [],
      restro_id: "",
      start_date: "",
      rest: "",
      end_date: "",
      type: "",
      page: 1,
      totalPages: 1,
      total: 0,
      reservationtotal: 0,
      per_page: 10,
      booking_status: "",
      booking_type: "",
      queryStartDate: "",
      queryEndDate: "",
      queryFilterBy: "",
      queryRestroId: "",
      hitFilterBtn: 0,
      isFilterValid: true,
    };

    this.fetchData = this.fetchData.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handlePerRowsChange = this.handlePerRowsChange.bind(this);
    this.fetchQueryParam = this.fetchQueryParam.bind(this);
    this.QueryReservationFilter = this.QueryReservationFilter.bind(this);
  }

  componentDidMount() {
    this.fetchRestData();
    this.fetchOutletData();
    this.fetchQueryParam();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.search !== prevProps.location.search) {
      this.fetchQueryParam();
    }
  }

  fetchQueryParam() {
    const query = new URLSearchParams(this.props.location.search);
    const start_date = query.get("start_date");
    const end_date = query.get("end_date");
    const restro_id = query.get("restro_id");
    const type = query.get("type");

    if (start_date && end_date && type) {
      this.setState(
        { start_date, end_date, type, rest: restro_id, hitFilterBtn: 1 },
        () => {
          this.QueryReservationFilter(start_date, end_date, type, restro_id);
        }
      );
    } else if (restro_id) {
      this.setState({ type, rest: restro_id, hitFilterBtn: 1 }, () => {
        this.QueryReservationFilter(start_date, end_date, type, restro_id);
      });
    } else if (start_date && end_date && type && restro_id) {
      this.setState(
        { start_date, end_date, type, rest: restro_id, hitFilterBtn: 1 },
        () => {
          this.QueryReservationFilter(start_date, end_date, type, restro_id);
        }
      );
    } else {
      if (this.state.hitFilterBtn === 0) {
        this.fetchData(this.state.page, this.state.per_page);
      }
    }
  }

  QueryReservationFilter(
    startDate,
    endDate,
    filterBy,
    RestroId,
    page = this.state.page,
    per_page = this.state.per_page
  ) {
    if (!startDate && !endDate && !filterBy && !RestroId) {
      alert("Please Select Any Filter");
      return;
    }

    if (startDate && !endDate) {
      alert("Please select end date");
      return;
    }

    if (endDate && !startDate) {
      alert("Please select start date");
      return;
    }
    var end_date = endDate;
    var start_date = startDate;

    if (RestroId === undefined) {
      var rest = "";
    } else {
      var rest = RestroId;
    }

    var type = filterBy;
    var booking_type = this.booking_type;

    let a = localStorage.getItem("user");
    let b = JSON.parse(a);
    let user_id = b.id;
    let restro_id = b.restro_id;

    axios
      .post(endpoints.reservationFilter, {
        start_date,
        end_date,
        rest,
        type,
        user_id,
        restro_id,
        booking_type,
        page,
        per_page,
      })
      .then((response) => {
        this.setState({
          items: response.data.data,
          reservationtotal: response.data.total,
          totalPages: response.data.total_pages,
          DataisLoaded: true,
        });
        // console.log(response.data);
      });
  }

  fetchData(page, per_page) {
    let a = localStorage.getItem("user");
    let b = JSON.parse(a);
    let type = "2";
    let restro_id = b.restro_id;
    axios
      .post(endpoints.getBooking, {
        restro_id,
        type,
        page,
        per_page,
      })
      .then((response) => {
        this.setState({
          items: response.data.data,
          reservationtotal: response.data.total,
          totalPages: response.data.total_pages,
          DataisLoaded: true,
        });
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
        // Optionally set DataisLoaded to true to stop the loader if there's an error
        this.setState({ DataisLoaded: true });
      });
  }

  fetchRestData() {
    let a = localStorage.getItem("user");
    let b = JSON.parse(a);

    axios.post(endpoints.getRestaurentsDropDown, {}).then((response) => {
      this.setState({
        restaurent: response.data.data,
        total: response.data.total,
        totalPages: response.data.total_pages,
        DataisLoaded: true,
      });
      // console.log(response.data);
    });
  }

  fetchOutletData() {
    let a = localStorage.getItem("user");
    let b = JSON.parse(a);
    let user_id = b.id;
    let restro_id = b.restro_id;
    axios
      .post(endpoints.getOutlet, {
        restro_id,
        user_id,
      })
      .then((response) => {
        this.setState({
          restaurent_outlet: response.data.data,
          total: response.data.total,
          totalPages: response.data.total_pages,
          DataisLoaded: true,
        });
        // console.log('outlet ',response.data);
      });
  }

  handlePageChange(page) {
    if (this.state.hitFilterBtn === 0) {
      this.fetchData(page, this.state.per_page);
    } else if (this.state.isFilterValid) {
      this.QueryReservationFilter(
        this.state.start_date,
        this.state.end_date,
        this.state.type,
        this.state.rest,
        page,
        this.state.per_page
      );
    }
  }

  handlePerRowsChange(newPerPage, page) {
    this.setState({ per_page: newPerPage }, () => {
      if (this.state.hitFilterBtn === 0) {
        this.fetchData(page, newPerPage);
      } else if (this.state.isFilterValid) {
        this.QueryReservationFilter(
          this.state.start_date,
          this.state.end_date,
          this.state.type,
          this.state.rest,
          page,
          newPerPage
        );
      }
    });
  }

  render() {
    const { DataisLoaded } = this.state;
    const a = this.state.items;

    const b = this.state.total;

    const links = this.state.restaurent;
    const outlets = this.state.restaurent_outlet;
    const user = localStorage.getItem("user");
    const user_data = JSON.parse(user);
    this.restro_id = user_data.restro_id;
    // console.log(outlets)

    const dates = new Date();
    const month = JSON.stringify(dates.getMonth() + 1);
    const date = JSON.stringify(dates.getDate());
    const year = JSON.stringify(dates.getFullYear());
    const recent_date = month + "-" + date;

    const columns = [
      { name: "Name", selector: (row) => row.full_name },
      {
        name: "Email",
        selector: (row) => (row.email ? row.email : "-"),
        center: true,
        wrap: true,
      },

      { name: "Phone", selector: (row) => row.phone_no },
      {
        name: "No. of Persons",
        selector: (row) => row.no_persons,
        center: true,
      },
      {
        name: "Booking Date",
        selector: (row) => row.booking_date,
      },
      {
        name: "Booking Time",
        selector: (row) => row.booking_time,
      },
      {
        name: "Restaurant",
        selector: (row) => row.restro_name,

        wrap: true,
        cell: (row) => (
          <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
            {row.restro_name}
          </div>
        ),
      },
      {
        name: "Outlet",
        selector: (row) => (row.outlet_name ? row.outlet_name : "-"),
        center: true,
      },
      {
        name: "Status",
        selector: (row) => row.booking_status,
        sortable: true,
        cell: (row) => (
          <select
            name="booking_status"
            required
            className="form-control"
            onChange={(e) => removeStatusHandler(row.id, e)}
            value={row.booking_status}
          >
            <option value={row.booking_status}>{row.booking_status}</option>
            <option
              value="Confirmed"
              style={{
                ...(row.booking_status === "Confirmed"
                  ? { display: "none" }
                  : {}),
              }}
            >
              Confirm
            </option>
            <option
              value="Cancelled"
              style={{
                ...(row.booking_status === "Cancelled"
                  ? { display: "none" }
                  : {}),
              }}
            >
              Cancel
            </option>
          </select>
        ),
      },
    ];

    const onSubmit = async (e) => {
      this.filterfetch(e);
      // console.log(e)
    };
    const removeStatusHandler = async (id, e) => {
      // console.log('status-295',e.target.value)
      const status = e.target.value;
      var set = "";
      if (status === "Confirmed") {
        set = "Confirm";
      }
      if (status === "Cancelled") {
        set = "Cancel";
      }
      const confirmBox = window.confirm("Do you want to " + set + " Booking?");
      if (confirmBox === true) {
        await axios
          .post(endpoints.update_booking_status, { id, status })
          .then((response) => {});
        window.location.reload();
      }
    };

    const bFilter = () => {
      const { start_date, end_date, type, rest } = this.state;

      // Check if at least one filter is selected
      if (!start_date && !end_date && !type && !rest) {
        alert("Please Select Any Filter");
        this.setState({ isFilterValid: false });
        return;
      }

      this.setState({ isFilterValid: true, hitFilterBtn: 1 });

      // Fetch the data with the selected filters
      this.QueryReservationFilter(start_date, end_date, type, rest);

      this.props.history.replace({ search: "" });
    };

    const onStartChange = (e) => {
      // this.start_date = e.target.value
      this.setState({ start_date: e.target.value });
      //console.log(this.state.start_date , this.end_date, this.type, this.rest)
    };
    const onEndChange = (e) => {
      // this.end_date = e.target.value
      this.setState({ end_date: e.target.value });
    };

    const onTypeChange = (e) => {
      this.setState({ type: e.target.value });
      // this.type = e.target.value
    };

    const onBookingTypeChange = (e) => {
      this.booking_type = e.target.value;
    };

    const onRestChange = (e) => {
      this.setState({ rest: e.target.value });
      // this.rest = e.target.value
    };

    const ExpandedComponent = ({ data }) => (
      <div className="container-fluid px-4 py-3 bg-light rounded">
        <div className="row g-3">
          {/* Left Column */}
          <div className="col-lg-6 col-md-12">
            <div className="p-3 border rounded shadow-sm bg-white h-100">
              <h6 className="fw-bold mb-3 text-success border-bottom pb-2">
                Booking Details
              </h6>
              <table className="table table-borderless table-sm align-middle mb-0">
                <tbody>
                  <tr>
                    <th className="text-muted">Name</th>
                    <td className="text-dark fw-bold">
                      {data.full_name || "-"}
                    </td>
                  </tr>
                  <tr>
                    <th className="text-muted">Email</th>
                    <td className="text-dark fw-bold">{data.email || "-"}</td>
                  </tr>
                  <tr>
                    <th className="text-muted">Mobile</th>
                    <td className="text-dark fw-bold">
                      {data.phone_no || "-"}
                    </td>
                  </tr>
                  <tr>
                    <th className="text-muted">No. of Persons</th>
                    <td className="text-dark fw-bold">
                      {data.no_persons || "-"}
                    </td>
                  </tr>
                  <tr>
                    <th className="text-muted">Booking Date</th>
                    <td className="text-dark fw-bold">
                      {data.booking_date || "-"}
                    </td>
                  </tr>
                  <tr>
                    <th className="text-muted">Booking Time</th>
                    <td className="text-dark fw-bold">
                      {data.booking_time || "-"}
                    </td>
                  </tr>
                  <tr>
                    <th className="text-muted">Restaurant</th>
                    <td className="text-dark fw-bold">
                      {data.restro_name || "-"}
                    </td>
                  </tr>
                  <tr>
                    <th className="text-muted">Outlet</th>
                    <td className="text-dark fw-bold">
                      {data.outlet_name || "-"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Right Column */}
          <div className="col-lg-6 col-md-12">
            <div className="p-3 border rounded shadow-sm bg-white h-100">
              <h6 className="fw-bold mb-3 text-success border-bottom pb-2">
                Tracking Information
              </h6>
              <table className="table table-borderless table-sm align-middle mb-0">
                <tbody>
                  <tr>
                    <th className="text-muted">Source / UTM Source</th>
                    <td className="text-dark fw-bold">{data.source || "-"}</td>
                  </tr>

                  <tr>
                    <th className="text-muted">UTM Medium</th>
                    <td className="text-dark fw-bold">
                      {data.utm_medium || "-"}
                    </td>
                  </tr>
                  <tr>
                    <th className="text-muted">UTM Campaign</th>
                    <td className="text-dark fw-bold">
                      {data.utm_campaign || "-"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );

    const c = [
      {
        booking_date: "BOOKING DATE",
        booking_time: "BOOKING TIME",
        created_at: "CREATED AT",
        email: "EMAIL",
        full_name: "NAME",
        no_persons: "PERSON",
        phone_no: "NUMBER",
        outlet_name: "OUTLET NAME",
        restro_name: "RESTAURANT",
        source: "SOURCE",
        booking_status: "STATUS",
        utm_source: "UTM SOURCE",
        utm_campaign: "UTM CAMPAIGN",
        utm_medium: "UTM MEDIUM",
      },
    ];

    const tableData = {
      columns,
      data: a,
    };

    if (!DataisLoaded)
      return (
        <div className="spinner">
          <InfinitySpin
            visible={true}
            width="200"
            color="#fbaa1a"
            ariaLabel="infinity-spin-loading"
          />
        </div>
      );

    return (
      <>
        <h2>Reservation Leads</h2>
        <Card className="px-3 py-3">
          <form
            className="ui form"
            onSubmit={(e) => onSubmit(e)}
            encType="multipart/form-data"
          >
            <div className="row">
              <div className="col-md-3">
                <label>Start Date</label>
                <br />
                <TextField
                  fullWidth
                  id="start_date"
                  label="Start Date"
                  type="date"
                  name="start_date"
                  place="Start Date"
                  value={this.state.start_date}
                  onChange={(e) => onStartChange(e)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onKeyDown={(e) => e.preventDefault()}
                />
              </div>
              <div className="col-md-3">
                <label>End Date</label>
                <br />
                <TextField
                  fullWidth
                  id="end_date"
                  label="End Date"
                  type="date"
                  name="end_date"
                  place="End Date"
                  value={this.state.end_date}
                  onChange={(e) => onEndChange(e)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onKeyDown={(e) => e.preventDefault()}
                />
              </div>
              <div className="col-md-3">
                <label>Filter By</label>
                <select
                  name="status"
                  required
                  className="form-control"
                  value={this.state.type}
                  onChange={(e) => onTypeChange(e)}
                >
                  <option value="">Select</option>
                  <option value="1">By Booking Date</option>
                  <option value="2">By Created Date</option>
                </select>
              </div>

              <div className="col-md-3">
                <label>Lead Type</label>
                <select
                  name="booking_type"
                  required
                  className="form-control"
                  onChange={(e) => onBookingTypeChange(e)}
                >
                  <option value="">Select</option>
                  <option value="1">Reserve Table</option>
                  <option value="2">Reserve For Guest </option>
                </select>
              </div>

              {this.restro_id === 0 ? (
                <div className="col-md-3">
                  <label>Restaurant</label>
                  <select
                    name="rest"
                    required
                    className="form-control"
                    value={this.state.rest}
                    onChange={(e) => onRestChange(e)}
                  >
                    <option value="">Select Restaurant</option>
                    {links.map((e, key) => {
                      return (
                        <option key={key} value={e.id}>
                          {e.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              ) : (
                ""
              )}
              <div className="col col-3">
                <div className="mt-5 text-center">
                  <Button
                    className="w-50"
                    onClick={() => bFilter()}
                    style={{ color: "white" }}
                    variant="contained"
                    size="medium"
                  >
                    Filter
                  </Button>
                </div>
              </div>
            </div>
          </form>
        </Card>

        <div>
          <DataTableExtensions {...tableData} filter={false}>
            <DataTable
              columns={columns}
              data={a}
              defaultSortField="id"
              pagination
              paginationServer
              highlightOnHover
              paginationTotalRows={this.state.reservationtotal}
              onChangePage={this.handlePageChange}
              onChangeRowsPerPage={this.handlePerRowsChange}
              progressPending={!this.state.DataisLoaded}
              expandableRows
              expandableRowsComponent={ExpandedComponent}
              customStyles={customStyles}
            />
          </DataTableExtensions>
        </div>
      </>
    );
  }
}
export default withRouter(ReservationLeads);
